<template>
    <div>
        <limitless-page-header :title="'Inventering'"></limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/stocktaking/table'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" sort-by="id" sort-order="desc" @rowclick="rowClick" history>
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                </div>
                <template #cell_id="{ row }">
                    <router-link :to="{ name: 'stocktaking.edit', params: { id: row.id } }">{{ row.id }}</router-link>
                </template>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import { hasPermission } from '@services/Helpers';

export default {
    name: 'DocumentList',
    components: {
        LimitlessPageHeader,
        RednaxDatatable,
    },
    props: {
        categories: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data: () => ({
        table_filter: {
            search: '',
        },
        table_columns: [
            {
                header: '#',
                data: 'id',
                sortable: true,
            },
            {
                header: 'Beskrivning',
                data: 'description',
                sortable: true,
            },
            {
                header: 'Startdatum',
                data: 'start_date',
                sortable: true,
            },
            {
                header: 'Status',
                data: 'status_id',
                sortable: true,
                render(row) {
                    if (row.status_id === 0) {
                        return 'Kommande';
                    }
                    if (row.status_id === 10) {
                        return 'Aktiv';
                    }
                    if (row.status_id === 100) {
                        return 'Avslutad';
                    }
                    return 'Unknown status';
                },
            },
        ],
    }),
    methods: {
        hasPermission,
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/stocktaking/' + row.id).focus();
            } else {
                this.$router.push({ name: 'stocktaking.edit', params: { id: row.id } });
            }
        },
    },
};

</script>
